import { useState, useEffect } from 'react';

/**
 * Detecta si la ventana del navegador está maximizada (ocupando toda la pantalla).
 * Compara las dimensiones externas de la ventana con las dimensiones disponibles de la pantalla.
 */
export function useIsMaximized() {
  const [maximized, setMaximized] = useState(true);

  useEffect(() => {
    const check = () => {
      const tolerance = 10;
      const isMaxWidth = window.outerWidth >= window.screen.availWidth - tolerance;
      const isMaxHeight = window.outerHeight >= window.screen.availHeight - tolerance;
      setMaximized(isMaxWidth && isMaxHeight);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return maximized;
}

export default useIsMaximized;